<div class="progress rounded-2">
  <div class="progress-bar rounded-2" [ngClass]="{'bg-success': percentComplete >= 100, 'bg-warning': hasWarning}" [style.width]="percentComplete + '%'"></div>
</div>
